import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, mappingResultError, Result, UseCase } from '@digibricks/domains';
export var UPDATE_QUESTION_ANSWER_USE_CASE = 'UPDATE_QUESTION_ANSWER_USE_CASE';
export var UpdateAnswerUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateAnswerUseCase, _UseCase);

  var _super = _createSuper(UpdateAnswerUseCase);

  function UpdateAnswerUseCase() {
    _classCallCheck(this, UpdateAnswerUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(UpdateAnswerUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var currentQuestion, data, answerId, updatedResults, description, question, answer, updatedAnswerResult, imgTagRegex, imagesInDescription, urls, foundFiles, resultCombine;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentQuestion = input.currentQuestion, data = input.data, answerId = input.answerId;
                updatedResults = [];
                description = data.description;
                question = currentQuestion;
                answer = question.answers.find(function (answer) {
                  return answer.id.toString() === answerId;
                });

                if (answer) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", new BadInputError('Answer does not exist in question'));

              case 7:
                if (!description) {
                  _context.next = 16;
                  break;
                }

                updatedAnswerResult = answer.updateDescription(description);

                if (!updatedAnswerResult.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", mappingResultError(updatedAnswerResult));

              case 11:
                imgTagRegex = /<img[^>]*>/g;
                imagesInDescription = description.match(imgTagRegex);
                urls = imagesInDescription === null || imagesInDescription === void 0 ? void 0 : imagesInDescription.map(function (i) {
                  // eslint-disable-next-line no-useless-escape
                  var regex = /(?<=src=\")([^\"]+)/;
                  var match = regex.exec(i);

                  if (match) {
                    return match[1];
                  }
                });

                if (urls) {
                  foundFiles = answer.files.filter(function (f) {
                    return urls.find(function (u) {
                      return u === f.url;
                    });
                  });
                  answer.updateFiles(foundFiles);
                } else {
                  answer.updateFiles([]);
                }

                updatedResults.push(question.updateAnswer(answer));

              case 16:
                resultCombine = Result.combine(updatedResults);

                if (!resultCombine.isFailure) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", mappingResultError(resultCombine));

              case 19:
                return _context.abrupt("return", Result.ok(question));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateAnswerUseCase;
}(UseCase);